// noinspection SpellCheckingInspection

import React, { useEffect, useState } from 'react';
import styles from './Instructions.module.css';
import newReservationScreenshot from '../../assets/images/new_reservation.png'
import addedScreenshot from '../../assets/images/added.png'
import viewReservationsScreenshot from '../../assets/images/status.png'
import paymentScreenshot from '../../assets/images/payment.png'
import periodicPay1Screenshot from '../../assets/images/periodicPay1.png'
import periodicPay2Screensho from '../../assets/images/periodicPay2.png'
import redirectToMemberFeeButtonScreenshot from '../../assets/images/redirectToMemberFeeButton.png'
import memberFeeFormScreenshot from '../../assets/images/memberFeeForm.png'
import memberFeePayedScreenshot from '../../assets/images/memberFeePayd.png'
import feeForNonMemberScreenshot from '../../assets/images/nmenber.png'
import equipmentCornerScreenshot from '../../assets/images/equipmentCornerScreenshot.JPG'

const Instructions = () => {

    const [showScrollButton, setShowScrollButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollButton(window.scrollY > 300);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <div className={styles.instructionsContainer}>
            <div className={styles.toc}>
                <h2>Spis treści</h2>
                <br/>
                <ul>
                    <li><a href="#rejestracja">1. Rejestracja</a></li>
                    <li><a href="#rezerwacja">2. Dodanie rezerwacji</a></li>
                    <li><a href="#anulowanie">3. Anulowanie rezerwacji</a></li>
                    <li><a href="#platnosci">4. Płatności</a></li>
                    <li><a href="#skladki">5. Składki członkowskie</a></li>
                    <li><a href="#statusy">6. Statusy rezerwacji</a></li>
                    <li><a href="#kod">7. Kod do drzwi</a></li>
                    <li><a href="#equipmentCorner">8. Wypożyczenie rakiet i piłek</a></li>
                    <li><a href="#selfService">9. Samoobsługa na korcie - zasady</a></li>
                </ul>
            </div>
            <div className={styles.instructionText}>
                <h5 id="rejestracja">1. Rejestracja</h5>
                <p>📝 Aby zarezerwować kort, potrzebujesz <strong>konta użytkownika</strong>.</p>
                <ul>
                    <li>▶ Wybierz <strong>"Zarejestruj się"</strong> w formularzu logowania.</li>
                    <li>▶ Uzupełnij dane i potwierdź e-mail (link aktywacyjny ważny 24h).</li>
                    <li>▶ Adres e-mail służy do logowania i odzyskiwania hasła.</li>
                </ul>
                <p>❗ Podanie nieprawdziwych danych może skutkować zawieszeniem konta.</p>
            </div>

            <div className={styles.instructionText}>
                <h5 id="rezerwacja">2. Dodanie nowej rezerwacji</h5>

                <div className={styles.imageContainer}>
                    <img src={newReservationScreenshot} alt="Rezerwacja" className={styles.floatingImageLeft}/>
                    <p>
                        ✅ <strong>Czerwone pola</strong> — zajęte. <br/>
                        ✅ <strong>Jasne pola</strong> — dostępne. <br/>
                        ✅ Kliknij, aby zaznaczyć (<strong>niebieski</strong>), zatwierdź <strong>"Rezerwuj"</strong> — wtedy zmienia się na <strong>zielony</strong>.
                    </p>
                </div>

                <div className={styles.imageContainer}>
                    <img src={addedScreenshot} alt="Rezerwacja dodana" className={styles.floatingImageRight}/>
                    <p>❗ Rezerwacji nie dodasz, jeśli masz zaległe płatności.</p>
                </div>
            </div>

            <div className={styles.instructionText}>
                <h5 id="anulowanie">3. Anulowanie rezerwacji</h5>
                <div className={styles.imageContainer}>
                    <img src={viewReservationsScreenshot} alt="Przegląd rezerwacji"
                         className={styles.floatingImageLeft}/>
                    <p>
                        ✅ Zielone komórki to Twoje rezerwacje. <br/>
                        ✅ Możesz anulować do momentu jej rozpoczęcia (przycisk <strong>"X"</strong> w zakładce „Rezerwacje” lub klik w komórkę). <br/>
                    </p>
                    <p>
                        ❗ Administrator może anulować rezerwację — sprawdź e-mail przed grą.
                    </p>
                </div>
            </div>

            <div className={styles.instructionText}>
                <h5 id="platnosci">4. Płatności</h5>
                <div className={styles.imageContainer}>
                    <img src={paymentScreenshot} alt="Płatności" className={styles.floatingImageRight}/>
                    <p>
                        💳 Płatność możliwa od momentu rozpoczęcia rezerwacji. <br/>
                        ✅ Nieanulowana rezerwacja = obowiązek zapłaty. <br/>
                        ✅ Kliknij <strong>"Płacę"</strong>, wybierz metodę (np. BLIK), potwierdź w systemie transakcyjnym przelewy 24.
                    </p>
                </div>

                <div className={styles.imageContainer}>
                    <img src={periodicPay1Screenshot} alt="Płatność okresowa 1" className={styles.floatingImageLeft}/>
                    <p>
                        💡 Możesz też opłacić <strong>pakiet okresowy</strong> (7, 14, 30 dni). <br/>
                    </p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={periodicPay2Screensho} alt="Płatność okresowa 2" className={styles.floatingImageRight}/>
                    <p>
                        ➡️ Opłata okresowa daje do 2h dziennie gry, od momentu wpłaty. <br/><br/>
                        ⏰ W razie złej pogody — przedłużenie automatyczne.
                    </p>
                </div>
            </div>
            <div className={styles.instructionText}>
                <h5 id="skladki">5. Składki członkowskie</h5>

                <div className={styles.imageContainer}>
                    <img src={redirectToMemberFeeButtonScreenshot} alt="Przycisk do składki"
                         className={styles.floatingImageLeft}/>
                 </div>

                <p>
                    🤝 Kliknij <strong>"Chcę opłacić składkę BTT"</strong> w zakładce „Płatności”. <br/>
                </p>

                <div className={styles.imageContainer}>
                    <img src={memberFeeFormScreenshot} alt="Formularz składki BTT"
                         className={styles.floatingImageLeft}/>
                    <p>
                        ✅ Wybierz opcję, zaakceptuj statut, ponieważ opłacając składę stajesz się członkiem BTT. <br/>
                    </p>
                </div>

                <div className={styles.imageContainer}>
                    <img src={memberFeePayedScreenshot} alt="Opłacona składka BTT"
                         className={styles.floatingImageRight}/>
                    <p>
                        ✅ Po opłaceniu składki członkowskiej — brak opłat za korty w przypadku gry z innymi członkami BTT.
                    </p>
                </div>

                <div className={styles.imageContainer}>
                    <img src={feeForNonMemberScreenshot} alt="Gracz spoza BTT" className={styles.floatingImageLeft}/>
                    <p>
                        ⚠️ Gracz spoza BTT? Zaznacz <strong>"Dopłata za gracza spoza BTT"</strong> — +40% stawki godzinowej.
                    </p>
                </div>
            </div>

            <div className={styles.instructionText}>
                <h5 id="statusy">6. Statusy rezerwacji</h5>
                <ul>
                    <li>📝 <b>REG</b> — rezerwacja zarejestrowana (do zapłaty)</li>
                    <li>✅ <b>PAY</b> — rezerwacja opłacona</li>
                    <li>📅 <b>PER</b> — rezerwacja w ramach opłaty okresowej</li>
                    <li>❌ <b>CAN</b> — rezerwacja anulowana (brak obowiązku zapłaty)</li>
                    <li>🏅 <b>MEM</b> — rezerwacja w ramach składki członkowskiej BTT</li>
                    <li>💸 <b>NME</b> — rezerwacja z dopłatą za gracza spoza BTT (do zapłaty)</li>
                </ul>
            </div>


            <div className={styles.instructionText}>
                <h5 id="kod">7. Kod do drzwi</h5>

                <p>
                    Do otwarcia drzwi budynku klubowego służy <strong>zamek cyfrowy</strong> znajdujący się przy wejściu.
                    Należy użyć <strong>indywidualnego, niepowtarzalnego kodu</strong> przypisanego do Twojego konta.
                    Po wejściu zadbaj o bezpieczeństwo rzeczy znajdujących się w budynku, a po zakończonej grze i przed opuszczeniem kortów
                    <strong> upewnij się, że drzwi zostały zamknięte</strong>.
                </p>

                <p>Instrukcja obsługi zamka:</p>

                 <ul>
                    <li>▶ Wprowadź kod i zatwierdź przyciskiem <strong>#</strong></li>
                    <li>▶ Aby skasować ostatnią cyfrę – użyj <strong>*</strong></li>
                </ul>

                <p>
                    🔐 Każdy gracz posiada <strong>indywidualny kod dostępu</strong>. Można go znaleźć po zalogowaniu w zakładce:
                    <strong>Dane &gt; Profil</strong>
                </p>

                <p>
                    🟢 <strong>Kody członków BTT</strong> są zawsze aktywne. <br/>

                    🕒 <strong>Kody pozostałych użytkowników</strong> działają wyłącznie od <strong>10 minut przed</strong> rezerwacją do <strong>10 minut po</strong> jej zakończeniu.
                </p>

                <p>
                    ❗ <strong>Nie udostępniaj swojego kodu</strong> innym osobom — jest przypisany wyłącznie do Twojego konta.
                </p>

                <p>
                    ⛔ <strong>Po 3 błędnych próbach </strong> wprowadzenia kodu następuje czasowa blokada systemu na <strong>5 minut</strong>.
                </p>

                <p>
                    ✉️ Jeśli chcesz zmienić kod lub masz pytania, napisz do: <a href="mailto:admin@btt.org.pl"><strong>admin@btt.org.pl</strong></a>
                </p>

            </div>

            <div className={styles.instructionText}>
                <h5 id="equipmentCorner">8. Wypożyczenie rakiet i piłek</h5>
                <div className={styles.imageContainer}> <img src={equipmentCornerScreenshot} alt="Kącik sprzętowy" className={styles.floatingImageLeft}/>
                    <p> W budynku klubowym znajduje się <strong>kącik z rakietami i piłkami</strong>, które można <strong>bezpłatnie wypożyczać</strong> na czas gry.
                        <br/><br/> ✅ Sprzęt jest dostępny wyłącznie dla osób posiadających aktywną rezerwację kortu w BTT. <br/><br/> ✅ Wypożyczenie działa w formule
                        <strong> samoobsługowej</strong>. Wejście do budynku możliwe jest za pomocą <strong>indywidualnego kodu</strong>,
                        widocznego w zakładce „Profil” po zalogowaniu. Kod jest aktywny od <strong>10 minut przed</strong> rezerwacją do <strong>10 minut po</strong> jej zakończeniu.
                        <br/><br/> ✅ Rakiety są podzielone na wieszaki dla <strong>dorosłych</strong> i <strong>dzieci. </strong>
                         Prosimy o odkładanie pożyczonego sprzętu na odpowiednie miejsce po zakończeniu gry. <br/>

                        <br/> ❗ Sprzętu nie należy zabierać do domu. <br/>

                        <br/> ℹ️ Sprzęt nie jest nowy — idealnie sprawdzi się dla osób rozpoczynających przygodę z tenisem.
                    </p> </div>
            </div>

            <div className={styles.instructionText}>
                <h5 id="selfService">9. Samoobsługa na korcie — zasady</h5>
                <p>
                    Korty w BTT funkcjonują w formule <strong>samoobsługowej</strong>, co oznacza, że każdy użytkownik odpowiada za przygotowanie i pozostawienie kortu w odpowiednim stanie po grze. Zasady te są szczególnie ważne dla nowych graczy. <br/><br/>

                    ✅ <strong>Polewanie kortu:</strong> W ciepłe dni (gdy kort jest suchy) należy <strong>obowiązkowo polać kort wodą</strong> — przed rozpoczęciem gry, w razie potrzeby w trakcie, oraz po zakończeniu meczu. Niedopuszczalne jest siatkowanie kortu, gdy unoszą się kłęby mączki. Podczas polewania należy kierować dyszę w górę; kierowanie strumienia w dół może uszkodzić nawierzchnię. <br/><br/>

                    ✅ <strong>Bezpieczeństwo budynku:</strong> W przypadku otwarcia drzwi budynku za pomocą indywidualnego kodu należy zadbać o bezpieczeństwo rzeczy znajdujących się w środku, a po grze <strong>upewnić się, że drzwi są zatrzaśnięte</strong>. <br/><br/>

                    ✅ <strong>Porządek:</strong> Nie należy pozostawiać żadnych śmieci na korcie — prosimy o zabranie ich ze sobą. <br/><br/>

                    ✅ <strong>Siatkowanie kortu:</strong> Po zakończonej grze należy <strong>zasiatkować kort</strong>. Instrukcję prawidłowego siatkowania można zobaczyć tutaj:
                    <a href="https://www.youtube.com/shorts/RWvcP2KylrY" target="_blank" rel="noopener noreferrer"> film instruktażowy</a>. <br/><br/>

                    🎾 Dziękujemy za dbałość o kort i życzymy udanej gry!
                </p>
            </div>


            {showScrollButton && (
                <button
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className={styles.backToTopButton}
                    aria-label="Powrót na górę"
                >
                    ↑
                </button>
            )}

        </div>
    );
};

export default Instructions;